import { defineComponent as l, openBlock as n, createBlock as o, unref as r, mergeProps as p, withCtx as d, createElementVNode as a } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const s = /* @__PURE__ */ l({
  name: "IconBackMarketApp",
  __name: "IconBackMarketApp",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(c) {
    const t = c;
    return (u, e) => (n(), o(r(m), p(t, { "view-box": "0 0 24 24" }), {
      default: d(() => [...e[0] || (e[0] = [
        a("path", { d: "M10.015 16.311a.3.3 0 0 0 .211.089h2.486a.076.076 0 0 0 .054-.13l-3.938-3.98a.13.13 0 0 1 0-.18l3.938-3.979a.077.077 0 0 0-.054-.13h-2.485a.3.3 0 0 0-.212.089l-3.978 4.02a.13.13 0 0 0 0 .18l3.978 4.021" }, null, -1),
        a("path", { d: "m17.978 16.27-3.938-3.98a.13.13 0 0 1 0-.18l3.938-3.98A.077.077 0 0 0 17.924 8h-2.486a.3.3 0 0 0-.21.089l-3.98 4.02a.13.13 0 0 0 0 .18l3.98 4.022a.3.3 0 0 0 .21.089h2.486a.076.076 0 0 0 .053-.13" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M14.32 2.25H9.68c-1.146 0-2.053 0-2.783.06C6.15 2.37 5.523 2.498 4.95 2.79a4.95 4.95 0 0 0-2.162 2.16c-.291.573-.418 1.2-.48 1.947C2.25 7.627 2.25 8.534 2.25 9.68v4.638c0 1.147 0 2.054.06 2.784.06.746.188 1.374.48 1.946a4.95 4.95 0 0 0 2.16 2.162c.573.291 1.2.418 1.947.48.73.059 1.637.059 2.784.059h4.638c1.147 0 2.054 0 2.784-.06.746-.06 1.374-.188 1.946-.48a4.95 4.95 0 0 0 2.162-2.16c.291-.573.418-1.2.48-1.947.059-.73.059-1.637.059-2.784V9.681c0-1.147 0-2.054-.06-2.784-.06-.746-.188-1.374-.48-1.946a4.95 4.95 0 0 0-2.16-2.162c-.573-.291-1.2-.418-1.947-.48-.73-.059-1.637-.059-2.784-.059M5.631 4.126C5.957 3.96 6.366 3.858 7.019 3.805 7.681 3.75 8.527 3.75 9.714 3.75h4.572c1.187 0 2.033 0 2.695.055.653.053 1.062.155 1.387.32a3.45 3.45 0 0 1 1.506 1.507c.166.325.268.734.321 1.387.054.662.055 1.508.055 2.695v4.572c0 1.187 0 2.033-.055 2.695-.053.653-.155 1.062-.32 1.387a3.45 3.45 0 0 1-1.507 1.506c-.325.166-.734.268-1.387.321-.662.054-1.508.055-2.695.055H9.714c-1.187 0-2.033 0-2.695-.055-.653-.053-1.062-.155-1.387-.32a3.45 3.45 0 0 1-1.506-1.507c-.166-.325-.268-.734-.321-1.387-.054-.662-.055-1.508-.055-2.695V9.714c0-1.187 0-2.033.055-2.695.053-.653.155-1.062.32-1.387a3.45 3.45 0 0 1 1.507-1.506",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
